<template lang="pug">
  .tabs-mobile
    editable-tab(
      v-for="(item,idx) in visibleItems"
      :key="idx"
      :item="item"
      :count="visibleItems.length"
      @update="update")
    .tabs-dropdown.ml-1(v-if="dropdownItems.length")
      v-dropdown(
        ref="dropdown"
        auto-close
        position-right
        width-auto)
        template(slot-scope="{ toggled }")
          v-btn(
            icon
            light-gray
            square)
            font-awesome-icon(
              size="sm"
              icon="chevron-down"
              :style="{ transform: `rotate(${toggled ? 180 : 0}deg)` }")
        .tabs-dropdown__content(
          ref="dropdownContent"
          slot="content")
          v-card(
            elevated)
            .tabs-dropdown__wrapper
              .tabs-dropdown__item.mb-2(
                v-for="item in dropdownItems"
                :key="item.id"
                @click="selectTab(item)")
                span.tabs-dropdown__item-title {{ item.name }}
              //- v-btn(
              //-   light-gray
              //-   block)
              //-   span + {{ 'base.add' | translate }}
</template>

<script>
import EditableTab from './EditableTab'
import { getFarmPath } from '@/util/app.js'
export default {
  name: 'TabsMobile',

  components: {
    EditableTab
  },

  props: {
    tabs: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  computed: {
    loading () {
      return parseInt(this.$route.query.loading)
    },

    selectedIndex () {
      return this.tabs
        .findIndex(item => item.loading === this.loading)
    },

    visibleItems () {
      return Array.of(this.tabs[this.selectedIndex])
    },

    dropdownItems () {
      return this.tabs
        .filter(item => !this.visibleItems
          .some(el => el === item))
    }
  },

  methods: {
    selectTab (item) {
      const farmId = this.$route.params.farm_id
      const clientId = this.$route.params.client_id
      const plannedOn = this.$route.query.date
      const loading = item.loading
      const basePath = clientId
        ? `/app/clients/${clientId}/farms/${farmId}`
        : `${getFarmPath(null, this.$route)}`
      const path = `${basePath}/planning?loading=${loading}&date=${plannedOn}`
      this.$router.replace(path)
    },

    update () {
      this.$emit('update')
    }
  },
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_variables.scss';

  .tabs-dropdown {
    &__content {
      width: 25rem;
    }

    &__wrapper {
      padding: 2rem;
    }

    &__item {
      display: flex;
      align-items: center;
      height: 4rem;
      width: 100%;
      padding: 0 1.2rem;
      border-radius: .8rem;
      background-color: $color-gray-light-5;
      cursor: pointer;
      transition: .3s linear;

      &:hover,
      &:focus {
        background-color: lighten($color-gray-light-5, 5%);
      }

      &-title {
        display: inline-block;
        max-width: 18rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 17px;
        font-weight: 600;
      }
    }
  }
</style>
